import { confirmAlert } from 'react-confirm-alert';

export function messageGlobal(
   custom={
      message:"",
      option:{
         refresh:false,
         direct:false,
      },
      value:""
   }
){

   const { message,option, value } = custom;
   const { refresh,direct } = option;

   if(refresh){
      confirmAlert({
         title: '',
         message: `${message}`,
         buttons: [
            {
               label: 'Refresh',
               onClick: () => window.location.href = value
            },
            {
               label: 'Tutup',
               onClick: () => false
            }
         ]
      })
   }else if(direct){
      confirmAlert({
         title: '',
         message: `${message}`,
         buttons: [
            {
               label: 'Tutup',
               onClick: () => window.location.href = value
            }
         ]
      })
   }
}

export function messageShow(opt){
   confirmAlert({
      title: '',
      message: `${opt}`,
      buttons: [
         {
            label: 'Tutup',
            onClick: () => false
         }
      ]
   })
}


export function messageGagal(opt){
   confirmAlert({
      title: '',
      message: `${opt}`,
      buttons: [
         {
            label: 'Tutup',
            onClick: () => false
         }
      ]
   })
}


// WEBPACK FOOTER //
// ./src/_utils/message.js